export class DigiTrainerContent {
    static MODAL_ID = 'digiTrainerModal';

    training: {
        competence: Array<any>;
        exercises: Array<any>;
        individual: Array<any>;
        passend: Array<any>;
        // bookmark: string|Array<any>;
        // progress: number|string;
    };

    merge(content: DigiTrainerContent): void {
        // if (typeof this.meta === 'object' && typeof content.meta === 'object') {
        //     this.meta = this.mergeObjects(this.meta, content.meta);
        // }

        // if (typeof this.context === 'object' && typeof content.context === 'object') {
        //     this.context = this.mergeObjects(this.context, content.context);
        // }

        // if (Array.isArray(content.assignments)) {
        //     this.assignments = this.assignments.concat(content.assignments);
        // }
        const combinedCompetence = [
            ...(this.training.competence ?? []),
            ...(content.training.competence ?? [])
        ];
        this.training.competence = this.removeDuplicates(combinedCompetence);

        //this.training.passend = (this.training.passend ?? []).concat(content.training.passend ?? []);
        const combinedExercises = [
            ...(this.training.passend ?? []),
            ...(content.training.passend ?? []),
            ...(this.training.exercises ?? []),
            ...(content.training.exercises ?? [])
        ];
        this.training.exercises = this.removeDuplicates(combinedExercises);

        this.training.individual = content.training.individual ?? [];
        // this.training.bookmark = (this.training.bookmark ?? '') + ' ' + (content.training.bookmark ?? '');
        // this.training.progress = (this.training.progress ?? '') + ' ' + (content.training.progress ?? '');
    }

    private removeDuplicates<T extends { id: any }>(array: Array<T>): Array<T> {
        if (!array) {
            return [];
        }

        const map = new Map<any, T>();

        array.forEach((item) => {
            if (!map.has(item.id)) {
                map.set(item.id, item);
            }
        })

        return Array.from(map.values());
    }

    // private mergeObjects(obj1: any, obj2: any): any {
    //     const mergedObject = { ...obj1 };
    //
    //     for (const key in obj2) {
    //         if (obj2.hasOwnProperty(key)) {
    //             const value1 = obj1[key];
    //             const value2 = obj2[key];
    //
    //             if (typeof value1 === 'string' && typeof value2 === 'string') {
    //                 mergedObject[key] = value1 + ' ' + value2;
    //             } else if (typeof value1 === 'object' && typeof value2 === 'object') {
    //                 mergedObject[key] = this.mergeObjects(value1, value2);
    //             } else {
    //                 mergedObject[key] = value2;
    //             }
    //         }
    //     }
    //
    //     return mergedObject;
    //
    // }
}
